// extracted by mini-css-extract-plugin
export default {"section":"GalleryPage_section__YN7tj","heading":"GalleryPage_heading__nnWT2"};